import {
  ADMIN_PREFILL_PRICING_LOADED,
  ADMIN_PREFILL_PRICING_CLEAR,
  ADMIN_PREFILL_ONBOARDING_SUCCESS,
  ADMIN_PREFILL_ONBOARDING_CLEAR,
} from '../actionTypes';
import * as api from '../apiHelper';
import {
  setFetchLoaderLoading,
  setFetchLoaderReset,
  setSubmissionLoaderLoading,
  setSubmissionLoaderReset,
} from '../fetchLoaderActions';
import { arriveNotice } from '../noticeActions';

// --- Reducer corresponding actions ---
export function adminPrefillPricingLoaded(pricing) {
  return {
    type: ADMIN_PREFILL_PRICING_LOADED,
    payload: { pricing },
  };
}

export function adminPrefillPricingClear() {
  return { type: ADMIN_PREFILL_PRICING_CLEAR };
}

export function adminPrefillOnboardingSuccess(result) {
  return {
    type: ADMIN_PREFILL_ONBOARDING_SUCCESS,
    payload: { result },
  };
}

export function adminPrefillOnboardingClear() {
  return { type: ADMIN_PREFILL_ONBOARDING_CLEAR };
}

// --- API functions ---
async function fetchPrefillPricingApi(token, dispatch) {
  const response = await api.get({
    path: 'common/customer-onboardings/pricing',
    version: 'gateway',
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

async function createPrefillOnboardingApi(token, body, dispatch) {
  const response = await api.post({
    path: 'common/customer-onboardings/admin/prefill',
    version: 'gateway',
    token,
    body,
    dispatch,
    isAdminRoute: true,
    customError: true,
  });
  return response;
}

// --- Public component actions ---
export function fetchAdminPrefillPricingRequest() {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken }, fetchLoader: { dataLoading } } = getState();
      if (!dataLoading) dispatch(setFetchLoaderLoading());
      const pricing = await fetchPrefillPricingApi(adminToken, dispatch);
      dispatch(adminPrefillPricingLoaded(pricing));
    } catch (e) {
      if (e.name !== 'AbortError') dispatch(arriveNotice(e.message));
    } finally {
      dispatch(setFetchLoaderReset());
    }
  };
}

export function clearAdminPrefillPricingRequest() {
  return (dispatch) => dispatch(adminPrefillPricingClear());
}

export function initiateCreatePrefillOnboardingRequest(requestBody, onError) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken }, fetchLoader: { submissionLoading } } = getState();
      if (!submissionLoading) dispatch(setSubmissionLoaderLoading());

      const response = await createPrefillOnboardingApi(adminToken, requestBody, dispatch);

      if (!response.ok) {
        const json = await response.json();
        const message = json.message || 'Failed to create prefill onboarding link.';
        const error = new Error(message);
        error.statusCode = response.status;
        throw error;
      }

      const json = await response.json();
      const camelResponse = api.camelizeKeys(json);
      dispatch(adminPrefillOnboardingSuccess(camelResponse));
      dispatch(arriveNotice('Prefill onboarding link created.', 'ok'));
    } catch (e) {
      if (onError) onError(e);
      else dispatch(arriveNotice(e.message));
    } finally {
      dispatch(setSubmissionLoaderReset());
    }
  };
}

export function clearAdminPrefillOnboardingRequest() {
  return (dispatch) => dispatch(adminPrefillOnboardingClear());
}
